var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "m-dialog",
    _vm._g(
      _vm._b(
        {
          staticClass: "form-dialog",
          model: {
            value: _vm.isDialogOpen,
            callback: function($$v) {
              _vm.isDialogOpen = $$v
            },
            expression: "isDialogOpen"
          }
        },
        "m-dialog",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.header
        ? _c("div", { attrs: { slot: "header", level: 1 }, slot: "header" }, [
            _vm._v("\n    " + _vm._s(_vm.header) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "body", level: 1 }, slot: "body" },
        [_vm._t("body")],
        2
      ),
      _vm._v(" "),
      _vm.ok
        ? _c(
            "m-button",
            {
              staticClass: "mdc-dialog__button accept-button",
              attrs: {
                slot: "acceptButton",
                disabled: !_vm.allowOkay,
                "data-mdc-dialog-action": "OK"
              },
              slot: "acceptButton"
            },
            [_vm._v("\n    " + _vm._s(_vm.ok) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.cancel
        ? _c(
            "m-button",
            {
              staticClass: "mdc-dialog__button",
              attrs: {
                slot: "cancelButton",
                "data-mdc-dialog-action": "Cancel"
              },
              slot: "cancelButton"
            },
            [_vm._v("\n    " + _vm._s(_vm.cancel) + "\n  ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }